import { render, staticRenderFns } from "./communicateLog.vue?vue&type=template&id=78768390&scoped=true&"
import script from "./communicateLog.vue?vue&type=script&lang=js&"
export * from "./communicateLog.vue?vue&type=script&lang=js&"
import style0 from "./communicateLog.vue?vue&type=style&index=0&id=78768390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78768390",
  null
  
)

export default component.exports